<template>
    <div>
        <!--        <pay :recharge="recharge" @payClose="payClose"></pay>-->
        <pay :recharge="recharge" @payClose="payClose"></pay>
        <div class="tip_bottom" @click="custom" v-show="isShowTipBottom">
        </div>
        <div class="tip_bottom_text" v-show="isShowTipBottom ">
            <div class="flexDiv" @click="custom">
                <div class="bottom_text_1">✔︎ 专业标书定制</div>
                <div class="bottom_text_2"> 🟢快速专人对接</div>
                <div class="bottom_text_3">
                    立即咨询
                    <a-icon type="edit" theme="filled"/>
                </div>
            </div>
            <div class="bottom_text_4" @click="closeTipBottom">
                <a-icon class="bottom_close_icon" type="close-circle" theme="filled"/>
            </div>

        </div>
        <div class="tip_left" v-show="isShowTipLeft && !isContent">
            <div class="tip_left_close" @click="closeTipLeft">
                <a-icon type="close-circle"/>
            </div>
            <img src="../../assets/image/img/promote_charge.jpg"
                 class="responsive-image" @click="getCharge()"/>
        </div>


        <div class="tip_bottom" v-show="isShowTipBottom">
            <div class="bottom"></div>
        </div>
        <div class="tip_right">
            <div @click="custom" class="span_right tip-item tip-custom bid_dz">
                <div class="tip_img tip-icon"><a-icon type="form"/></div>
                <div class="tip_title">标书定制</div>
            </div>
            <div class="span_right tip-item tip-wechat bid_gzh">
                <a-popover placement="left" overlayClassName="tip-popover-overlay">
                    <template slot="content">
                        <div class="tip-popover-card tip-popover-qr">
                            <div class="flex_gzh">
                                <img class="tip-qr-img" src="../../assets/image/img/icon_gzh_img.jpg" alt="微信公众号">
                                <div>微信公众号</div>
                            </div>
                            <div class="flex_gzh">
                                <img class="tip-qr-img" src="../../assets/image/img/icon_ewm.png"
                                     alt="微信专属客服">
                                <div>微信专属客服</div>
                            </div>
                        </div>
                    </template>
                    <div class="tip_img tip-icon"><a-icon type="wechat"/></div>
                    <div class="tip_title">公众号</div>
                </a-popover>
            </div>
            <div class="span_right tip-item tip-service bid_chat">
                <div class="czx_atm_next_ccc">
                    <div class="czx_atm_next">
                        <div class="czx_A">
                            <a-icon type="customer-service"/>
                            在线客服
                        </div>
                        <div class="czx_B">
                            <p class="czx_BA">工作时间：9:00-17:30</p>
                            <p class="czx_BB">工作电话：{{ phone }}</p>
                        </div>
                        <div class="czx_C">
                            <a-button @click="chatCustom"
                                      class="service-contact-btn"
                                      icon="customer-service">联系客服
                            </a-button>
                        </div>
                        <div v-show="isQuestion" class="czx_D">
                            <a class="tip-link" href="javascript:void (0)" @click="question">
                                <a-icon type="exclamation-circle"/>
                                常见问题</a>
                        </div>
                    </div>
                </div>
                <div class="tip_img tip-icon"><a-icon type="customer-service"/></div>
                <div class="tip_title">在线客服</div>
            </div>
            <div @click="opinion" class="span_right tip-item tip-feedback bid_dz">
                <div class="tip_img tip-icon"><a-icon type="edit"/></div>
                <div class="tip_title">意见反馈</div>
            </div>
            <div class="span_right tip-item tip-favorite collection" @click="bookmark">
                <div class="lachesism_atm_next_ccc">
                    <div class="lachesism_atm_next">
                        <div class="lachesism_B">
                            <p class="lachesism_BA">收藏本站</p>
                            <div class="favorite_shortcut">
                                <p class="lachesism_BB">【Crtl + D】</p>
                                <p class="lachesism_BC">快速收藏本站</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tip_img tip-icon"><a-icon type="star"/></div>
                <div class="tip_title">收藏本站</div>
            </div>
        </div>
        <a-modal
                :footer="null"
                width="600px"
                :dialog-style="{ top: '200px',borderRadius:'30px',padding:0}"
                :visible="opinionShow"
                :maskClosable="false"
                @cancel="() => setModal1Visible(false)"
        >
            <div class="tip_opinion">
                <div class="opinion_title">感谢你留下宝贵的建议</div>
                <div class="opinion_content">
                    <div class="opinion_content_body">
                        <div class="opinion_left">反馈类型：</div>
                        <div class="opinion_right opinion_type_group">
                            <a-button @click="form.type=0" :class="form.type===0 ? 'spans_active':'spans'">找不到文档
                            </a-button>
                            <a-button @click="form.type=1" :class="form.type===1 ? 'spans_active':'spans'">使用问题
                            </a-button>
                            <a-button @click="form.type=2" :class="form.type===2 ? 'spans_active':'spans'">其他
                            </a-button>
                        </div>
                    </div>
                    <div class="opinion_content_body">
                        <div class="opinion_left"><b class="required_mark">*</b> 反馈内容：</div>
                        <div class="opinion_right">
                            <a-textarea
                                    v-model="form.feedback"
                                    placeholder="请填写问题描述以便我们提供更好的帮助"
                                    :auto-size="{ minRows: 8, maxRows: 15 }">
                            </a-textarea>
                        </div>
                    </div>
                    <div v-if="isLogin ? false:true" class="opinion_content_body opinion_contact_row">
                        <div class="opinion_left"><b class="required_mark">*</b> 联系方式：</div>
                        <div class="opinion_right">
                            <a-input class="opinion_phone_input" v-model="form.phone" placeholder="请输入手机号码"></a-input>
                        </div>
                    </div>

                </div>
                <div class="opinion_submit">
                    <a-button @click="submitOpinion" type="primary">提交</a-button>
                </div>
            </div>
        </a-modal>
        <login :login-show="loginShows" @submitLoginClose="submitLoginClose" @loginSuccess="loginSuccess"></login>
    </div>
</template>

<script>
import {navigateUrl} from "@/utils/resToData";
import {decrypt} from "@/utils/AES";
import {addfeedback} from "@/api/page/moduleTopic";
import {phoneNumCheck} from "@/utils/checked";
import {addBehavior} from "@/data/accessKey";
import {getAgreement} from "@/api/page/public";
import login from "@/views/page_login/login.vue";
import pay from "@/views/page_pay/pay.vue";
import {parseTime} from "@/utils/parse";

export default {
    name: "view_right_tip",
    components: {pay, login},
    data() {
        return {
            isShowTipLeft: true,
            loginShows: false,
            recharge: false,
            phone: process.env.VUE_APP_PHONE,
            opinionShow: false,
            formLayout: 'horizontal',
            form: {feedback: '', phone: '', type: 0},
            isLogin: false,
            isQuestion: false,
            questionValue: {},
            beginTime: Date.parse(new Date()),
            isShowTipBottom: true,
            isContent: false
        }
    },

    methods: {
        closeTipBottom() {
            const currentTime = new Date();
            const futureTime = new Date(currentTime.getTime() + 60 * 10 * 1000);
            localStorage.setItem("isShowTipBottom", JSON.stringify({
                value: "false",
                expiration: futureTime.toLocaleString()
            }));
            this.isShowTipBottom = false
        },
        payClose() {
            this.recharge = false
        },
        loginSuccess() {
            this.$bus.$emit('loginSuccessInfo', true)
            this.isLogin = true
            this.loginShows = false
        },
        submitLoginClose() {
            this.loginShows = false
        },
        question() {
            this.$router.push({path: '/webState', query: {change: this.questionValue.id}})
        },
        getStoredUser() {
            const user = localStorage.getItem('userInfo')
            if (!user) {
                return null
            }
            try {
                return JSON.parse(decrypt(user))
            } catch (err) {
                return null
            }
        },
        getCharge() {
            if (localStorage.getItem('accessKey') && localStorage.getItem('userInfo')) {
                this.recharge = true
                //打开充值
            } else {
                this.loginShows = true
                //跳转登录
            }
        },
        closeTipLeft() {
            const currentTime = new Date();
            const futureTime = new Date(currentTime.getTime() + 60 * 10 * 1000);
            localStorage.setItem("isShowTipLeft", JSON.stringify({
                value: "false",
                expiration: futureTime.toLocaleString()
            }));
            this.isShowTipLeft = false
        },
        bookmark() {
            var url = 'https://www.biaoxiaozhu.cn/#/';
            var title = '标小助投标文件网';
            if (window.sidebar && window.sidebar.addPanel) { // Firefox
                window.sidebar.addPanel(title, url, '');
            } else if (window.external && ('AddFavorite' in window.external)) { // IE
                window.external.AddFavorite(url, title);
            } else if (window.opera && window.print) { // Opera
                var elem = document.createElement('a');
                elem.setAttribute('href', url);
                elem.setAttribute('title', title);
                elem.setAttribute('rel', 'sidebar');
                elem.click();
            } else { // Other browsers
                this.$message.info('请按 Ctrl + D 收藏本站')
            }
        },
        custom() {
            if (this.$route.path === '/custom') {
                this.$router.push({path: '/custom'}).catch(err => {
                })
            } else {
                navigateUrl('/custom')
            }
        },
        chatCustom() {
            // this.customeShow=false
            //
            // let hm = document.createElement("script");
            // hm.src = "https://hm.baidu.com/hm.js?efce94ff47728f12a211f329eec7c3ea";
            //
            // let s = document.getElementsByTagName("script")[0];
            // s.parentNode.insertBefore(hm, s);

            // //方法三、在小窗口弹出沟通窗口
            var url = "https://affim.baidu.com/unique_49213756/chat?siteId=19557841&userId=49213756&siteToken=efce94ff47728f12a211f329eec7c3ea";
            var name = "标小助"; //网页名称，可为空;
            var iWidth = 780; //弹出窗口的宽度;
            var iHeight = 600; //弹出窗口的高度;
            var iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
            var iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
            window.open(url, name, 'height=' + iHeight + ',,innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no');
        },

        opinion() {
            let user = this.getStoredUser()
            if (user) {
                this.form.phone = user.phone
            } else {
            }
            this.opinionShow = true
        },

        setModal1Visible() {
            this.form = {feedback: '', phone: '', type: 0}
            this.opinionShow = false
        },
        submitOpinion() {
            let user = this.getStoredUser()
            if (user) {
                this.form.phone = user.phone
                if (this.form.feedback === '') {
                    this.$message.error('反馈内容为必填')
                } else {

                    addfeedback(this.form).then(res => {
                        this.opinionShow = false
                        this.$message.success('反馈成功，等待管理员反馈')
                        this.form = {feedback: '', phone: '', type: 0}
                    }).catch(err => {
                        this.$message.error('提交失败，请稍后重试')
                    })
                }
            } else {
                if (this.form.feedback === '') {
                    this.$message.error('反馈内容为必填')
                } else if (this.form.phone === '') {
                    this.$message.error('手机号码为必填')
                } else {
                    if (phoneNumCheck(this.form.phone)) {
                        addfeedback(this.form).then(res => {
                            this.opinionShow = false
                            addBehavior('意见反馈', '意见反馈', location.href, this.beginTime, Date.parse(new Date()))
                            this.$message.success('反馈成功，等待管理员反馈')
                            this.form = {feedback: '', phone: '', type: 0}
                        }).catch(err => {
                            this.$message.error('提交失败，请稍后重试')
                        })
                    } else {
                        this.$message.error('手机号码格式不正确')
                    }
                }
            }
        },


    },

    mounted() {
        var currentURL = window.location.href;
        if (currentURL.includes('content?doc') || currentURL.includes('custom')) {
            this.isShowTipBottom = false;
        }
        if (currentURL.includes('content?doc') && localStorage.getItem('userInfo')) {
            this.isContent = true
        } else {
            this.isContent = false
        }
        let user = this.getStoredUser()
        if (user) {
            this.form.phone = user.phone
            this.isLogin = true
        } else {
            this.isLogin = false
        }
        if (localStorage.getItem("isShowTipLeft")) {
            const data = JSON.parse(localStorage.getItem("isShowTipLeft"));
            if (data && data.expiration.toLocaleString() < new Date().toLocaleString()) {
                localStorage.removeItem("isShowTipLeft");
                this.isShowTipLeft = true;
            } else {
                this.isShowTipLeft = false;
            }
        }
        if (localStorage.getItem("isShowTipBottom")) {
            const data = JSON.parse(localStorage.getItem("isShowTipBottom"));
            if (data && data.expiration.toLocaleString() < new Date().toLocaleString()) {
                localStorage.removeItem("isShowTipBottom");
                this.isShowTipBottom = true;
            } else {
                this.isShowTipBottom = false;

            }
        }
        getAgreement().then(res => {
            if (res) {
                res.forEach(value => {
                    if (value.name === '常见问题') {
                        this.isQuestion = true
                        this.questionValue = value
                    }
                })
            }
        })

    },


    watch: {
        opinionShow(newValue, oldValue) {
            if (newValue) {
                let user = this.getStoredUser()
                if (user) {
                    this.form.phone = user.phone
                    this.isLogin = true
                } else {
                    this.isLogin = false
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.tip_bottom {
  position: fixed;
  top: auto;
  bottom: 0;
  width: 100%;
  height: 64px;
  min-height: 64px;
  z-index: 998;
  background: rgba(17, 24, 39, 0.78);
  backdrop-filter: blur(10px);
}

.tip_bottom_text {
  cursor: pointer;
  position: fixed;
  top: auto;
  bottom: 0;
  width: 100%;
  height: 64px;
  min-height: 64px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexDiv {
  display: flex;
  width: min(820px, calc(100% - 88px));
  align-items: center;
  justify-content: center;
  gap: 18px;
  color: white;
  font-family: inherit;

}

.bottom_text_1 {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0;
}

.bottom_text_2 {
  margin: 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 15px;
  font-weight: 600;
}

.bottom_text_3 {
  margin: 0 0 0 8px;
  font-family: inherit;
  background: #f6974b;
  color: white;
  padding: 8px 20px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 800;
  box-shadow: 0 8px 22px rgba(246, 151, 75, 0.34);
  animation: pulse 1.8s ease-in-out infinite;
}

.bottom_text_4 {

  position: fixed;
  top: auto;
  right: 16px;
  bottom: 17px;
  left: auto;
  color: rgba(255, 255, 255, 0.72);
}

.bottom_close_icon {
  font-size: 30px;
}

@keyframes pulse {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-5px);
  }

  100% {
    transform: translateY(0);
  }
}


.tip_left {
  z-index: 999;
  position: fixed;
  min-height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 188px;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

.tip_left_close {
  position: static !important;
  order: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  top: auto !important;
  right: auto !important;
  left: auto !important;
  width: 30px;
  height: 30px;
  margin: 8px auto 0 !important;
  opacity: 0.72 !important;
  color: rgba(17, 24, 39, 0.62);
  background: rgba(255, 255, 255, 0.86);
  border-radius: 50%;
  box-shadow: 0 8px 18px rgba(17, 24, 39, 0.12);
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.tip_left_close:hover {
  opacity: 0.95 !important;
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(17, 24, 39, 0.16);
}


.responsive-image:hover {
  animation: scaleAnimation 2s infinite;

}

@keyframes scaleAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.035);
  }
  100% {
    transform: scale(1);
  }
}

.closeRightTip {
  margin-left: 10px;
  font-size: 40px;

}

.closeRightTip :hover {
  opacity: 0.8;
  cursor: pointer;
}

.tip_right {
  position: fixed;
  right: 24px;
  top: 50%;
  z-index: 998;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 76px;
  padding: 8px 6px;
  margin-top: 0;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(226, 232, 240, 0.88);
  border-radius: 18px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.13);
  backdrop-filter: blur(8px);
  transform: translateY(-50%);

  .span_right {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 68px;
    margin-top: 0;
    padding: 7px 5px;
    overflow: visible;
    user-select: none;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
    cursor: pointer;
    transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;

    .tip_img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      color: #ffffff;
      font-size: 25px;
      line-height: 1;
      transition: transform 0.22s ease;
    }

    .tip_title {
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.2;
      white-space: normal;
      word-break: keep-all;
    }
  }

  .span_right:hover {
    filter: brightness(1.04);
    transform: translateX(-4px);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.18);
  }

  .span_right:hover .tip_img {
    transform: translateY(-1px);
  }

  .span_right:active {
    transform: translateX(-4px) scale(0.97);
  }

  .bid_dz {
    background: linear-gradient(135deg, #2F80ED, #1D6FE8);
  }

  .bid_gzh {
    background: linear-gradient(135deg, #20C997, #12B886);
  }

  .bid_chat {
    background: linear-gradient(135deg, #22B8CF, #15AABF);
  }

  .bid_chat:hover .czx_atm_next_ccc {
    display: block;
  }

  .tip-feedback {
    background: linear-gradient(135deg, #F6C343, #E0A928);
  }

  .collection {
    background: linear-gradient(135deg, #FF9F43, #FF7A1A);
  }

  .collection:hover .lachesism_atm_next_ccc {
    display: block;
  }
}

::v-deep .tip-popover-overlay .ant-popover-inner {
  overflow: hidden;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);
}

::v-deep .tip-popover-overlay .ant-popover-inner-content {
  padding: 12px;
}

::v-deep .tip-popover-overlay .ant-popover-arrow {
  border-top-color: #ffffff !important;
  border-right-color: #ffffff !important;
}

.tip-popover-card {
  display: flex;
  gap: 14px;
  min-width: 268px;
  color: #333333;
  font-size: 13px;
}

.flex_gzh {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 118px;
  font-weight: 700;
  text-align: center;
}

.tip-qr-img {
  width: 122px;
  height: 122px;
  object-fit: contain;
  border: 1px solid #eef2f7;
  border-radius: 10px;
}

.tip_opinion {
  width: 100%;
  min-height: 410px;
  padding: 8px 14px 10px;
  box-sizing: border-box;

  .opinion_title {
    width: 100%;
    color: #1f2937;
    font-size: 21px;
    font-weight: 800;
    line-height: 1.4;
    text-align: center;
  }

  .opinion_content {
    width: 100%;
    min-height: 300px;
    margin-top: 22px;

    .opinion_content_body {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      min-height: 50px;
      margin-bottom: 16px;

      .opinion_left {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 0 0 118px;
        height: 40px;
        padding-right: 14px;
        color: #4b5563;
        font-size: 15px;
        font-weight: 700;
        background: #fff;
        box-sizing: border-box;
      }

      .opinion_right {
        display: flex;
        flex: 1 1 auto;
        min-width: 0;
        min-height: 40px;
        color: #333333;
        font-size: 15px;
        background: #fff;

        .spans,
        .spans_active {
          min-width: 92px;
          height: 36px;
          margin-right: 10px;
          color: #4b5563;
          border: 1px solid #dfe6f0;
          border-radius: 18px;
          background: #ffffff;
          transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
        }

        .spans:hover,
        .spans:focus,
        .spans_active {
          color: #2080e5;
          border-color: rgba(32, 128, 229, 0.42);
          background: rgba(32, 128, 229, 0.07);
        }
      }

      .opinion_type_group {
        align-items: center;
        flex-wrap: wrap;
        gap: 8px 0;
      }
    }

    .opinion_contact_row {
      margin-top: 15px;
    }
  }

  .required_mark {
    margin-right: 3px;
    color: #cc404d;
  }

  .opinion_phone_input {
    height: 44px;
    border-radius: 8px;
  }

  ::v-deep .ant-input {
    border-radius: 8px;
  }

  ::v-deep textarea.ant-input {
    line-height: 1.7;
  }

  .opinion_submit {
    width: 100%;
    margin-top: 18px;
    text-align: center;

    button {
      width: 224px;
      height: 44px;
      background: #2080E5;
      border-radius: 22px;
      border-color: #2080E5;
      font-size: 16px;
      font-weight: 700;
      box-shadow: 0 10px 22px rgba(32, 128, 229, 0.22);
      transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
    }

    button:hover,
    button:focus {
      filter: brightness(1.03);
      transform: translateY(-1px);
      box-shadow: 0 14px 28px rgba(32, 128, 229, 0.28);
    }

    button:active {
      transform: translateY(0) scale(0.98);
    }
  }
}

.czx_atm_next_ccc,
.lachesism_atm_next_ccc {
  position: absolute;
  right: calc(100% + 12px);
  top: 50%;
  display: none;
  width: max-content;
  height: auto;
  background: none;
  transform: translateY(-50%);
}

.czx_atm_next,
.lachesism_atm_next {
  position: relative;
  width: 264px;
  min-height: auto;
  padding: 18px 18px 16px;
  box-sizing: border-box;
  color: #334155;
  text-align: left;
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.94);
  border-radius: 14px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.16);
}

.czx_atm_next::after,
.lachesism_atm_next::after {
  position: absolute;
  top: 50%;
  right: -7px;
  width: 14px;
  height: 14px;
  content: "";
  background: #ffffff;
  border-top: 1px solid rgba(226, 232, 240, 0.94);
  border-right: 1px solid rgba(226, 232, 240, 0.94);
  transform: translateY(-50%) rotate(45deg);
}

.czx_A {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  color: #111827;
  font-size: 17px;
  font-weight: 800;
}

.czx_B {
  margin-top: 12px;

  .czx_BA,
  .czx_BB {
    padding: 0;
    margin: 0;
    color: #64748b;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.8;
  }
}

.czx_C {
  width: 100%;
  margin-top: 14px;
}

.service-contact-btn {
  width: 100%;
  height: 38px;
  color: #ffffff;
  font-weight: 700;
  background: #2080E5;
  border-color: #2080E5;
  border-radius: 19px;
}

.service-contact-btn:hover,
.service-contact-btn:focus {
  color: #ffffff;
  background: #1b73d1;
  border-color: #1b73d1;
}

.czx_D {
  width: 100%;
  margin-top: 12px;
  font-weight: 800;
}

.tip-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #334155;
  font-size: 14px;
}

.tip-link:hover,
.tip-link:focus {
  color: #2080E5;
}

.lachesism_atm_next {
  width: 224px;
  padding: 16px 18px;
}

.lachesism_BA {
  padding: 0;
  margin: 0;
  color: #111827;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.5;
}

.favorite_shortcut {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.lachesism_BB,
.lachesism_BC {
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}

.lachesism_BB {
  color: #ff7a1a;
}

.lachesism_BC {
  color: #64748b;
}

.responsive-image {
  display: block;
  order: 1;
  width: 184px;
  max-width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(17, 24, 39, 0.16);
}

@media (max-width: 1180px) {
  .tip_left {
    width: 156px;
  }

  .responsive-image {
    width: 154px;
  }

  .tip_right {
    right: 8px;
    transform: translateY(-50%) scale(0.92);
    transform-origin: right center;
  }
}

@media (max-width: 900px) {
  .tip_bottom,
  .tip_bottom_text,
  .tip_left,
  .tip_right {
    display: none;
  }
}

</style>
<style scoped>
>>> .ant-modal-content {
    border-radius: 19px;
}
</style>
